import { loadFullPage } from "./loadFullPage";
import { postFetch } from "./postFetch";
import { tomSelectBuscaLocalizacao } from "./eventoBuscarVagaRedirect";
import { toastErroCarregar } from "./toastErroCarregar";
import { toastSucesso } from './toastSucesso';
import JustValidate from "just-validate";
import { isNullOrEmpty } from "./isNullOrEmpty";
import { Confirm } from "notiflix/build/notiflix-confirm-aio";
import { inicializarInternacionalizacao } from "../localizacao/alertaVaga/alertaVaga";
import i18next from 'i18next';

export class AlertaVaga {
    constructor(botao) {
        this.botao = botao;
        this.modalGenerico = document.getElementById('modal-generico');
        this.vagaID = this.botao.getAttribute('data-vaga-id');
        this.profissaoID = this.botao.getAttribute('data-profissao-id');
        this.adicionais = this.botao.getAttribute('data-edicao') === 'true' || false;
        this.alertaID = parseInt(this.botao.getAttribute('data-alerta-id') ?? '0', 10) || 0;
        const localidadeAttr = this.botao.getAttribute('data-localidade');
        this.localidade = localidadeAttr ? localidadeAttr.split('|').map(l => l.trim()).filter(l => l) : null;

        this.recarregar = this.botao.getAttribute('data-recarregar') === 'true';

        const cargoAttr = this.botao.getAttribute('data-cargo');
        this.cargos = cargoAttr ? cargoAttr.split('|').map(c => c.trim()).filter(c => c) : null;

        this.devePreencherComCV = this.botao.getAttribute('data-preencher-curriculo') === 'true';

        this.tomSelectCargosInstance = null;
        this.tomSelectLocalidadesInstance = null;
        this.modalBootstrap = null;

        this.init = this.init.bind(this);
        this.submitForm = this.submitForm.bind(this);
        this.excluir = this.excluir.bind(this);

        if (!botao._alertaVagaListenerAttached) {
            botao.addEventListener('click', this.init);
            botao._alertaVagaListenerAttached = true;
        }
    }

    async init(event) {
        if (event) event.preventDefault();

        loadFullPage.mostrar();
        inicializarInternacionalizacao();

        this.alertaID = parseInt(this.botao.getAttribute('data-alerta-id') ?? '0', 10) || 0;

        const urlModal = `/${CULTURE_EMPREGARE}/PainelAlertaVaga/ModalAlerta?id=${this.alertaID}&adicionais=${this.adicionais}`;
        const resultadoModal = await fetch(urlModal);

        if (!resultadoModal.ok) {
            loadFullPage.esconder();
            toastErroCarregar(i18next.t('ErroGenerico'));
            return;
        }

        let sugestoesCargos = [];
        let sugestoesLocalidades = [];

        // Busca sugestões separadamente SE for novo alerta E deve preencher
        if (this.alertaID === 0 && this.devePreencherComCV) {
            const urlSugestoes = `/${CULTURE_EMPREGARE}/PainelAlertaVaga/SugerirDadosAlertaPeloCurriculo`;
            const resultadoSugestoes = await fetch(urlSugestoes);
            if (resultadoSugestoes.ok) {
                const responseJson = await resultadoSugestoes.json();
                if (responseJson.sucesso && responseJson.dados) {
                    sugestoesCargos = responseJson.dados.cargos || [];
                    sugestoesLocalidades = responseJson.dados.localidades || [];
                } else {
                    toastErroCarregar(i18next.t('ErroGenerico'));
                }
            } else {
                toastErroCarregar(i18next.t('ErroGenerico'));
            }
        }

        this.modalGenerico.innerHTML = await resultadoModal.text();

        this.modalGenerico.addEventListener('hidden.bs.modal', () => {
            this.tomSelectCargosInstance?.destroy();
            this.tomSelectLocalidadesInstance?.destroy();
            this.modalGenerico.innerHTML = '';
            this.modalBootstrap = null;
        }, { once: true });

        this.alertaID = parseInt(this.modalGenerico.querySelector('#alerta-id-modal')?.value ?? '0', 10) || 0;

        const form = this.modalGenerico.querySelector('#form-alerta-vaga');
        if (!form) throw new Error("Formulário #form-alerta-vaga não encontrado.");

        const formValidar = new JustValidate(form, {  lockForm: true });
        formValidar
            .addField('#CargosAlerta', [{ rule: 'required', errorMessage: i18next.t('ErrorMessageCargo') }])
            .onSuccess(this.submitForm);

        if ((this.vagaID || this.profissaoID) && this.alertaID === 0) {
            formValidar.removeField('#CargosAlerta');
        }

        // Preencher cargos do botão se existirem
        if (!isNullOrEmpty(this.cargos) && this.cargos.length > 0) {
            const containerCargos = this.modalGenerico.querySelector('#container-input-cargos');
            const selectCargos = this.modalGenerico.querySelector('#CargosAlerta');

            if (containerCargos && selectCargos) {
                const contagemOptions = containerCargos.querySelectorAll(`option`).length;

                this.cargos.forEach(value => {
                    const option = this.modalGenerico.querySelector(`option[value='${value}']`);
                    if (option && !option.selected) {
                        option.remove();
                    }
                });

                const html = [];
                for (const cargo of this.cargos) {
                    html.push(`<option value="${cargo}" ${contagemOptions > 0 ? '' : 'selected'}>${cargo}</option>`);
                }
                selectCargos.innerHTML += html.join('');
            }
        }

        // Preencher localidades do botão se existirem
        if (this.localidade != null && this.localidade.length > 0) {
            const selectCidade = this.modalGenerico.querySelector('#CidadeAlerta');
            if (selectCidade) {
                const contagemOptions = selectCidade.querySelectorAll(`option`).length;

                this.localidade.forEach(value => {
                    const option = selectCidade.querySelector(`option[value='${value}']`);
                    if (option && !option.selected) {
                        option.remove();
                    }
                });

                const html = [];
                for (const cidade of this.localidade) {
                    html.push(`<option value="${cidade}" ${contagemOptions > 0 ? '' : 'selected'}>${cidade}</option>`);
                }
                selectCidade.innerHTML += html.join('');
            }
        }

        await Promise.all([
            import('tom-select').then(async ({ default: TomSelect }) => {
                this.tomSelectCargosInstance = new TomSelect('#CargosAlerta', {
                    plugins: ['clear_button'],
                    maxItems: 5, create: true, persist: false, createOnBlur: true, searchField: [],
                    createFilter: (input) => input.length <= 150 || (toastErroCarregar(i18next.t("AlertaVagaErro150Caracteres")), false),
                    render: {
                        no_results: (data, escape) => (''),
                        option_create: (data, escape) => `<div class="create"><strong>${escape(data.input)}</strong></div>`
                    },
                    onInitialize: function () {

                    },
                    onChange: function (values) { }
                });

                if (sugestoesCargos.length > 0) {
                    sugestoesCargos.forEach(cargo => {
                        if (!this.tomSelectCargosInstance.options[cargo]) {
                            this.tomSelectCargosInstance.addOption({ value: cargo, text: cargo }, false);
                        }
                    });
                    this.tomSelectCargosInstance.setValue(sugestoesCargos, false);
                    this.tomSelectCargosInstance.refreshItems();
                }
            }),

            Promise.resolve(tomSelectBuscaLocalizacao('#CidadeAlerta')).then(instance => {
                const selectEl = document.getElementById('CidadeAlerta');
                const instanceFromElement = selectEl?.tomselect;
                this.tomSelectLocalidadesInstance = instance || instanceFromElement;

                if (this.tomSelectLocalidadesInstance) {
                    if (sugestoesLocalidades.length > 0) {
                        sugestoesLocalidades.forEach(local => {
                            if (!this.tomSelectLocalidadesInstance.options[local]) {
                                this.tomSelectLocalidadesInstance.addOption({ value: local, text: local }, false);
                            }
                        });
                        this.tomSelectLocalidadesInstance.setValue(sugestoesLocalidades, false);
                        this.tomSelectLocalidadesInstance.refreshItems();
                    }
                }
            }).catch(error => {
                toastErroCarregar(i18next.t('ErroGenerico'));
            })
        ]);

        this.modalGenerico.querySelector('#alerta-vaga-excluir')?.addEventListener('click', this.excluir);

        // Verificar se deve submeter automaticamente sem abrir a modal
        const isBtnCriarAlerta = this.botao.classList.contains("btn-criar-alerta");
        const isBtnNotificacao = this.botao.classList.contains("btn-abrir-modal-alerta");

        // Auto-submit apenas se:
        // 1. Tem vaga ou profissão específica (não é criação genérica)
        // 2. Não tem localidade OU tem apenas 1 localidade
        // 3. Não é edição de alerta existente
        // 4. Não é o botão de criar alerta do painel
        // 5. Não é o botão de notificação (deve sempre abrir modal)
        if ((this.vagaID || this.profissaoID) && (!this.localidade || this.localidade?.length == 1) && !this.alertaID && !isBtnCriarAlerta && !isBtnNotificacao) {
            loadFullPage.esconder();
            this.modalGenerico.querySelector('#form-alerta-vaga').dispatchEvent(new Event('submit'));
            return;
        }

        this.modalBootstrap = new bootstrap.Modal(this.modalGenerico, { backdrop: "static" });
        this.modalBootstrap.show();
        loadFullPage.esconder();


    }

    async excluir() {
        Confirm.init({
            className: "confirm-empregare",
            titleColor: "#EA1F1F",
            okButtonColor: "#f8f8f8",
            okButtonBackground: "#EA1F1F",
            cancelButtonColor: "#f8f8f8",
        });

        const callbackSucesso = resultado => {

            if (this.recarregar) {
                location.reload();
            }

            this.modalBootstrap.hide();
            loadFullPage.esconder();
            this.botao.dispatchEvent(new Event('alerta-excluido', { bubbles: true }));
            this.alertaID = 0;
            this.adicionais = false;
            this.botao.innerHTML = `<i class="bi bi-bell"></i> ${i18next.t('BtnAtivar')}`;
            this.botao.setAttribute('data-alerta-id', 0);

            toastSucesso(i18next.t('AlertaExcluido'))
        };

        const callbackErro = resultado => {
            toastErroCarregar(resultado.mensagem);
            loadFullPage.esconder();
            this.modalBootstrap.hide();
        }

        Confirm.show(
            i18next.t('ConfirmarExcluirTitulo'),
            i18next.t('ConfirmarExcluirTexto'),
            i18next.t('ConfirmarExcluirBtnConfirmar'),
            i18next.t('ConfirmarExcluirBtnCancelar'),
            async () => {
                loadFullPage.mostrar(i18next.t('ExcluindoAlerta'));
                await postFetch(`/${CULTURE_EMPREGARE}/PainelAlertaVaga/Excluir/${this.alertaID}`, null, callbackSucesso, callbackErro, callbackErro);
            }
        );
    }

    async submitForm(event) {
        event.preventDefault();
        loadFullPage.mostrar(i18next.t('LoadSalvandoAlerta'))

        const callbackSucesso = resultado => {
            toastSucesso(i18next.t('AlertaSalvo'))
            if (this.recarregar) {
                location.reload();
            }

            this.modalBootstrap?.hide();
            loadFullPage.esconder();
            this.alertaID = resultado.alertaID;
            this.adicionais = true;
            this.botao.innerHTML = '<i class="bi bi-gear"></i> ' + i18next.t('btnEditar');
            this.botao.setAttribute('data-alerta-id', resultado.alertaID);

            this.botao.dispatchEvent(new Event('alerta-salvo', { bubbles: true }));
        }

        const callBackErro = resultado => {
            //this.modalBootstrap?.hide();
            loadFullPage.esconder();

            if (resultado?.mensagem != null) {
                if (resultado.erroAutenticacao) {
                    document.querySelector('.btn-login').click();
                    return;
                }
                toastErroCarregar(resultado.mensagem);
                return;
            }

            toastErroCarregar(i18next.t('ErroGenerico'));
        }

        const formData = new FormData(event.target);

        formData.append('VagaID', this.vagaID);
        formData.append('ProfissaoID', this.profissaoID);
        formData.append('ID', this.alertaID);

        if (!formData.get('Localidades') && this.localidade) {
            formData.delete('Localidades');
            if (this.profissaoID || this.vagaID) {
                for (const localidade of this.localidade) {

                    formData.append('Localidades', localidade);
                }
            }
        }

        if (!formData.get('Cargos') && this.cargos && !isNullOrEmpty(this.cargos)) {
            formData.delete('Cargos');
            for (const cargo of this.cargos) {

                formData.append('Cargos', cargo);
            }
        }

        await postFetch(`/${CULTURE_EMPREGARE}/PainelAlertaVaga/Salvar`, formData, callbackSucesso, callBackErro, callBackErro, false, false);
    }
}
